module.exports = __webpack_public_path__ + "static/media/21ECLAC41.42e1c84d.jpg";